export const DISABLED_PAYMENT_INPUT_TITLE = "תשלום באמצעות כרטיס אשראי אינו זמין כעת. אנא בחרו אמצעי תשלום אחר";
